/** Bound concurrent reads; mutations do not wait behind page refreshes. */
export function createRequestLimiter(limit: number) {
  let active = 0;
  const waiting: Array<() => void> = [];
  return function acquire(signal: AbortSignal): Promise<() => void> {
    return new Promise((resolve, reject) => {
      const abort = () => {
        const index = waiting.indexOf(start);
        if (index >= 0) waiting.splice(index, 1);
        reject(signal.reason ?? new DOMException("Aborted", "AbortError"));
      };
      const start = () => {
        signal.removeEventListener("abort", abort);
        if (signal.aborted) {
          abort();
          waiting.shift()?.();
          return;
        }
        active++;
        let released = false;
        resolve(() => {
          if (released) return;
          released = true;
          active--;
          waiting.shift()?.();
        });
      };
      if (signal.aborted) {
        abort();
        return;
      }
      if (active < limit) start();
      else {
        waiting.push(start);
        signal.addEventListener("abort", abort, { once: true });
      }
    });
  };
}
